<template>
    <div>
        disable paygo asdasd
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import VrmHeader from '@/vue/components/layout/VrmHeader';
@Component({ components: { VrmHeader } })
@AngularRoute('base.installation.disable', '/disable-paygo', { slot: 'main' })
export default class DisabelPaygo extends Vue {
    @ngInject()
    ApiService;
}
</script>
